import { useState, useCallback, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import { authStore } from 'store/authStore';
import { CMM } from '../../Lib/Cmm.js';
import axios from 'axios';
import { fetchAxios, postAxios, postNoauth } from 'Lib/GetAxios';

import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Container,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from "reactstrap";

const Login = () => {
  const [email, setEmail] = useState([]);
  const [password, setPassword] = useState([]);

  //   // 값 저장
  // sessionStorage.setItem('key', 'value');
  // // 값 가져오기
  // const storedValue = sessionStorage.getItem('key');
  // // 값 삭제
  // sessionStorage.removeItem('key');
  // // 세션 스토리지 비우기 (전체 삭제)
  // sessionStorage.clear();

  const navigate = useNavigate();

  useEffect(() => {
    // sessionStorage.clear();
  }, [])


  const sendLogin = useCallback(async () => {

    console.log('LOGIN:::', email, password);

    if (!email) {
      return;
    }
    if (!password) {
      return;
    }

    // 인증코드 확인 (AuthCode 발급받음)
    let res = await postNoauth(`${CMM.SERVER_URL_AUTH}/login/`, {
      email: email,
      passwd: password
    }).then(async (res) => {
      if (res !== 'ERROR') {
        // console.log(res);

        console.log(':::::::::::::::::', res.message);

        let res2 = await postNoauth(`${CMM.SERVER_URL_AUTH}/oauth/token`, {
          code: res.message.code,
          client_secret: 'd3576ef400c8440284ef72642f806914',
          client_id: 'chatbot.co.kr',
          grant_type: 'access_token',
        }).then((res2) => {
          if (res2 !== 'ERROR') {
            console.log('res2:::', res2)

            // if (isRemember) {
            //   setCookie('rmbId', email, { maxAge: 2000 })
            // }

            authStore.updToken({ accToken: res2.access_token, refToken: res2.refresh_token });
            navigate('/admin');

            //window.location.href = '/admin';

          }

        }).catch((e2) => {
          console.log('error accessToken:: ', e2.message);
        });


      } else {
        setPassword('');

        toast.error('비밀번호가 일치하지 않습니다.', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: {
            // marginTop: '500px'
          }
        });
      }

    }).catch((e) => {
      // console.log('error authCode:: ', e.message);
      setPassword('');

      toast.error('비밀번호가 일치하지 않습니다.', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: {
          // marginTop: '500px'
        }
      });

      console.log('error', e);
    });

  }, [email, password]);

  const loingCheck = useCallback(() => {
    console.log('send:::', `email=${email}&password=${password}`)
    //계정 정보 확인
    axios.get(`${CMM.SERVER_URL_AUTH}/loing/email=${email}&password=${password}`)
      .then((res) => {
        if (res !== 'ERROR') {

          console.log(res.data.message);

          const user_idx = res.data.message[0].user_idx;
          const u_uuid = res.data.message[0].u_uuid;

          // console.log(user_idx);
          // console.log(u_uuid);

          //세션 스토리지에 데이터 저장
          sessionStorage.setItem('user_idx', user_idx);
          sessionStorage.setItem('u_uuid', u_uuid);

          navigate('/admin');

        }
      })
      .catch((e) => {

        toast.error('비밀번호가 일치하지 않습니다.', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: {
            // marginTop: '500px'
          }
        });

        console.log('error', e);
      });
  }, [email, password]);


  //엔터키 이벤트
  const activeEnter = (e) => {
    if (e.nativeEvent.isComposing) { 	   // isComposing 이 true 이면 
      return;				   // 조합 중이므로 동작을 막는다.
    }

    if (e.key === 'Enter' && e.shiftKey) { // [shift] + [Enter] 치면 걍 리턴
      return;
    } else if (e.key === 'Enter') {
      e.preventDefault();
      sendLogin(e);
    }
  };

  return (
    <>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <Col lg="5" md="7">
        <Container>
          <div className="header-body text-center mb-7">
            <Row className="justify-content-center">
              <Col lg="5" md="6">
                <h1 className="text-white">Welcome!</h1>
                {/* <p className="text-lead text-light">
                    Use these awesome forms to login or create new account in
                    your project for free.
                  </p> */}
              </Col>
            </Row>
          </div>
        </Container>
        <Card className="bg-secondary shadow border-0">

          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>박대리 챗봇 관리자 페이지 입니다.</small>
            </div>
            <Form role="form">
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  {/* 이메일 */}
                  <Input
                    placeholder="이메일"
                    type="email"
                    autoComplete="new-email"
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={(e) => activeEnter(e)}
                    value={email}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  {/* 비밀번호 */}
                  <Input
                    placeholder="비밀번호"
                    type="password"
                    autoComplete="new-password"
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e) => activeEnter(e)}
                    value={password}
                  />
                </InputGroup>
              </FormGroup>
              <div className="custom-control custom-control-alternative custom-checkbox">
                <input
                  className="custom-control-input"
                  id=" customCheckLogin"
                  type="checkbox"
                />
              </div>
              <div className="text-center">
                {/* <Link to="/admin"> */}
                <Button className="my-4" type="button" onClick={sendLogin}
                  style={{ backgroundColor: '#0D6EFD', color: '#ffffff' }}>
                  로그인
                </Button>
                {/* </Link> */}
              </div>
            </Form>
          </CardBody>
        </Card>
        <Row className="mt-3 px-5 text-black-50 ">
          <Col xs="6">
            <a
              className="text-light"
              href="#pablo"
              onClick={(e) => {
                e.preventDefault();
                navigate('/auth/user-password');
              }}
            >
              <small>비밀번호를 잊으셨나요?</small>
            </a>
          </Col>
          <Col className="text-right" xs="6">
            <a
              className="text-light"
              href="#pablo"
              onClick={(e) => {
                e.preventDefault();
                navigate('/auth/membership');
              }}
            >
              <small>관리자 계정 신청</small>
            </a>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default Login;
